import UserProfileBadge from './UserProfileBadge';

export default UserProfileBadge;
